export enum EPresetType {
  AddForm = 'AddForm',
  NewAddForm = 'NewAddForm',
  MyOffers = 'MyOffers',
}
